import { Loader } from '@thinknet-gmbh/platform-common-ui';

import { useRouteQuery } from 'src/common/helpers';
import { HOLIDAY_MANAGER_PAGE_COMPONENTS } from 'src/pages/settings/components/holiday-manager/holiday-manager.constants';

import { useGetPropsByCurrentPage } from './holiday-details.hooks';

const HolidayDetails = () => {
  const query = useRouteQuery();
  const id: string = query.get('id') || '';
  const page: string = query.get('page') || '';
  const HolidayPage = HOLIDAY_MANAGER_PAGE_COMPONENTS[page];

  const {
    data,
    loading,
    onFinish = values => console.log(values),
    onDelete = () => {},
  } = useGetPropsByCurrentPage(page, id);

  return loading ? <Loader /> : <HolidayPage data={data} onFinish={onFinish} onDelete={onDelete} />;
};

export default HolidayDetails;
